export const GET_ZONES = "GET_ZONES";
export const GET_SUB_ZONES = "GET_SUB_ZONES";
export const GET_AVAILABLE_TIMES = "GET_AVAILABLE_TIMES";
export const START_LOADING_AVAILABLE_TIMES = "START_LOADING_AVAILABLE_TIMES";
export const STOP_LOADING_AVAILABLE_TIMES = "STOP_LOADING_AVAILABLE_TIMES";
export const SCHEDULE_STARTS = "SCHEDULE_STARTS";
export const SCHEDULE_STOPS = "SCHEDULE_STOPS";
export const SCHEDULE_SUCCESS = "SCHEDULE_SUCCESS";
export const START_LOADING_SUBZONE = "START_LOADING_SUBZONE";
export const STOP_LOADING_SUBZONE = "STOP_LOADING_SUBZONE";

